<template>
    <div>
        <v-dialog v-model="abrir" persistent :width="width">
            <v-card class="pb-1">
                <v-card-title>
                    <span class="headline">Documentos / Información Movimientos de Aceite</span>
                </v-card-title>
                <v-progress-linear v-if="cargando" indeterminate color="blue darken-2"></v-progress-linear>
                <v-progress-linear v-if="error_load" indeterminate color="red darken-3"></v-progress-linear>
                <v-card-text class="pb-1">
                    <v-row>
                        <v-col cols="2">
                            <v-select
                                :items="tipo_producciones"
                                v-model="tipo_produccion_id"
                                label="Tipo Producción"
                                item-text="tipo_produccion"
                                item-value="id"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="tipo_movimientos"
                                v-model="tipo_movimiento"
                                label="Ingreso o Salida"
                                item-text="texto"
                                item-value="valor"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="motivo_movimientos"
                                v-model="motivo_movimiento"
                                label="Motivo Movimiento"
                                item-text="texto"
                                item-value="valor"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="documento" label="Documento / Información"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="tipo_datos"
                                v-model="tipo_dato"
                                label="Tipo Dato"
                                item-text="texto"
                                item-value="valor"
                            ></v-select>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field v-model="activo" label="Activo"></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-btn color="orange darken-1" label=" + "> + </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-col cols="6">
                        <alert></alert>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="green darken-1" dark @click="submit" :disabled="!validar"> Guardar </v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="indigo darken-1" dark @click="limpiar()">Limpiar</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="blue darken-1" dark @click="abrir = false">Cerrar</v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>

            <v-card>
                <template>
                    <div>
                        <v-data-table
                            :headers="cabeceras"
                            :items="lista_datitos"
                            item-key="name"
                            class="elevation-1"
                            :search="search"
                            :custom-filter="filterOnlyCapsText"
                        >
                            <template v-slot:top>
                                <v-text-field
                                    v-model="search"
                                    label="Búsqueda"
                                    class="mx-4"
                                ></v-text-field>
                            </template>

                            <template v-slot:item.activo="prop">
                                <v-row v-if="prop.item.tipo_dato == '5'">
                                    <v-col cols = "2">
                                        <v-btn class="ma-2" color="green" dark icon @click="ver_select(prop.item)">
                                            <v-icon dark>info</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols = "8">
                                        <v-text-field
                                            v-model="prop.item.activo"
                                            label="Agregar Opción"
                                            class="mx-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols = "2">
                                        <v-btn class="ma-2" color="indigo" dark icon @click="grabar_select(prop.item)">
                                            <v-icon dark>save</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </div>
                </template>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Alert from '@/components/shared/Alert.vue';
import { mapState, mapMutations } from 'vuex';
export default {
    data:()=>({
        tipo_producciones:[],
        tipo_produccion_id:'',
        tipo_movimientos:[],
        tipo_movimiento:'',
        motivo_movimientos:[],
        motivo_movimiento:'',
        tipo_datos:[],
        tipo_dato:'',
        lista_datos:[],
        documento:'',
        activo:1,
        despacho:{},
        abrir:false,
        cargando:false,
        error_load:false,
        search: '',
        cabeceras: [
            {
                text: 'Producción',
                align: 'start',
                //filterable: false,
                value: 'produccion',
            },
            { text: 'Movimiento', value: 'movimiento' },
            { text: 'Motivo Mov', value: 'motivo' },
            { text: 'Documento', value: 'documento' },
            { text: 'Tipo Dato', value: 'tipo' },
            { text: 'Activo', value: 'activo' },
        ],
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_docs');
    },
    mounted(){
        this.$parent.$on('abrir_modal_docs',(despacho)=>{
            console.log("despacho", despacho)
            this.despacho = despacho;

            this.limpiar();
            this.abrir = true;
            this.cargarDatos();
            this.listarDatos()
        });
        

    },
    methods:{

        async submit(){
            this.cargando = true;

            if (this.validar){
                console.log('enviando peticion');
                let url = `${this.base_url}mov_documentos`;
                let body = {
                    tipo_produccion_id: this.tipo_produccion_id,
                    tipo_movimiento:    this.tipo_movimiento,
                    motivo_movimiento:  this.motivo_movimiento,
                    documento:          this.documento,
                    tipo_dato:          this.tipo_dato,
                    activo:             this.activo,
                }

                await this.axios.post(url,body,this.headers).then((res)=>{
                    if(res.data.message != "Error"){
                        this.$emit('realizado');
                        //this.abrir = false;
                        this.documento = ''
                        this.listarDatos();
                        this.$emit('cargarDocumentos');
                    } else {
                        Event.$emit('mostrar_alert',{tipo: "success",mensaje: "Registro ya existe"});
                    }
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            } else {
                console.log('nope');
                Event.$emit('mostrar_alert',{tipo: "success",mensaje: "No están todos los datos"})
            }
            this.cargando = false;
        },

        limpiar(){
            this.tipo_produccion_id = '';
            this.tipo_movimiento = '';
            this.motivo_movimiento = '';
            this.documento = '';
            this.tipo_dato = '';
            this.activo = 1;
        },


        async cargarDatos(){
            this.cargando = true;
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            let url = `${this.base_url}mov_documento/cargar_datos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('cargar_datos',response);
                this.tipo_producciones = response.data.producciones;
                this.tipo_movimientos = response.data.movimientos;
                this.motivo_movimientos = response.data.motivos;
                this.tipo_datos = response.data.tipos;
                this.error_load = false;
            }).catch((error)=>{
                console.log(error);
                this.error_load = true;
            });
            this.cargando = false;
            this.ocultarLoading();
        },

        async listarDatos(){
            this.cargando = true;
            let url = `${this.base_url}mov_documento/listar_datos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('listar_datos',response.data);
                this.lista_datos = response.data.data;
                this.error_load = false;
            }).catch((error)=>{
                console.log(error);
                this.error_load = true;
            });
            this.cargando = false;
        },

        filterOnlyCapsText (value, search, item) {
            search = search.toLocaleUpperCase()
            return value != null && search != null && typeof value === 'string' && value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        async grabar_select(item){
            console.log("item", item)
            let data = {    "id": item.id,
                            "opcion": item.activo,
                        }
            let url = `${this.base_url}mov_documento/grabar_opcion`;
            await this.axios.post(url, data, this.headers).then((response) => {
                let resp = response.data.data;
                console.log("resp", resp)
                this.listarDatos()
            }).catch((error)=>{
                console.log(error);
            });

        },

        async ver_select(item){
            this.mostrarLoading({titulo:"Buscando datos...",color:'green'})
            console.log("item", item)
            let id =  item.id
            let url = `${this.base_url}mov_documento/ver_opciones/${id}`;
            await this.axios.get(url, this.headers).then((response) => {
                let resp = response.data.data;
                console.log("resp", resp)
                this.ocultarLoading();
                let datos = '';
                resp.forEach(row => { datos += row.opcion + " - " });
                this.mostrarLoading({titulo:datos, color:'blue darken-4'})
            }).catch((error)=>{
                console.log(error);
            });

        },
         ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{

        lista_datitos(){
            let retorno = true
            let listita = this.lista_datos.filter( row => {
                retorno = false
                if ((this.tipo_produccion_id == '') && (this.tipo_movimiento == '') && (this.motivo_movimiento == '') && (this.tipo_dato == '')){
                    retorno =  true;
                }
                if(this.tipo_produccion_id != ''){
                    if (row.tipo_produccion_id == this.tipo_produccion_id ){
                        retorno = true;
                    } else {
                        return false;
                    }
                }
                if(this.tipo_movimiento != ''){
                    if (row.tipo_movimiento == this.tipo_movimiento ){
                        retorno = true;
                    } else {
                        return false;
                    }
                }
                if(this.motivo_movimiento != ''){
                    if (row.motivo_movimiento == this.motivo_movimiento ){
                        retorno = true;
                    } else {
                        return false;
                    }
                }
                if(this.tipo_dato != ''){
                    if (row.tipo_dato == this.tipo_dato ){
                        retorno = true;
                    } else {
                        return false;
                    }
                }
                return retorno;
            });
            return listita;
        },
 
        validar(){
            if ((this.tipo_produccion_id != '') && (this.tipo_movimiento != '') && (this.motivo_movimiento != '') &&
                (this.tipo_dato != '') &&  (this.documento != '') && (this.activo != '')){
                return true;
            } else {
                return false;
            }

        },

        width () {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 320
            case 'sm': return 600
            case 'md': return 1000
            case 'lg': return 1400
            case 'xl': return 1800
            }
        },
        height () {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 200
            case 'sm': return 400
            case 'md': return 600
            case 'lg': return 800
            case 'xl': return 1000
            }
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker,
    }
}
</script>
<style>
.hidden{
    display: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background: #d2d6d8 !important;
    color: #212121 !important;
}
</style>